export type Theme = 'theme-isiparts' | 'theme-blue';
const defaultTheme: Theme = 'theme-isiparts';

export const initTheme = (theme: Theme): void => {
    if (theme === defaultTheme) {
        return;
    }

    const html = document.documentElement;
    html.classList.remove(defaultTheme);
    html.classList.add(theme);
};
